export default __webpack_public_path__ + "static/media/1753.33a09bdd.png";